import { EdpWidgetAdvantagesAndBenefitsComponent } from "@edp-components/edp-card-widgets/edp-widget-advantages-and-benefits/edp-widget-advantages-and-benefits.component";
import { EdpWidgetBannerComponent } from "@edp-components/edp-card-widgets/edp-widget-banner/edp-widget-banner.component";
import { EdpWidgetBillingComponent } from "@edp-components/edp-card-widgets/edp-widget-billing/edp-widget-billing.component";
import { EdpContractConsumptionsComponent } from "@edp-components/edp-card-widgets/edp-widget-consumptions";
import { EdpWidgetContaCertaComponent } from "@edp-components/edp-card-widgets/edp-widget-conta-certa/edp-widget-conta-certa.component";
import { EdpWidgetRequestsComponent } from "@edp-components/edp-card-widgets/edp-widget-requests/edp-widget-requests.component";
import { EdpWidgetFuncionaComponent } from "@edp-components/edp-card-widgets/edp-widget-funciona/edp-widget-funciona.component";
import { EdpWidgetHealthComponent } from "@edp-components/edp-card-widgets/edp-widget-health/edp-widget-health.component";
import { EdpWidgetMobilityComponent } from "@edp-components/edp-card-widgets/edp-widget-mobility/edp-widget-mobility.component";
import { EdpWidgetPartnersComponent } from "@edp-components/edp-card-widgets/edp-widget-partners/edp-widget-partners.component";
import { EdpWidgetPaymentDebtComponent } from "@edp-components/edp-card-widgets/edp-widget-payment-debt/edp-widget-payment-debt.component";
import { EdpWidgetSavingsComponent } from "@edp-components/edp-card-widgets/edp-widget-savings/edp-widget-savings.component";
import { EdpWidgetSmartNowComponent } from "@edp-components/edp-card-widgets/edp-widget-smart-now/edp-widget-smart-now.component";
import { EdpWidgetWithoutBillingComponent } from "@edp-components/edp-card-widgets/edp-widget-without-billing/edp-widget-without-billing.component";
import { FuncionaPlafond } from "@edp-components/edp-contract/edp-contract-details.model";
import { HasPackModel } from "@edp-components/edp-contract/edp-contract.model";
import { EdpSmartnowDashboardWidgetComponent } from "@edp-components/edp-smartnow-dashboard-widget/edp-smartnow-dashboard-widget.component";
import { EdpSmartnowNextBillingWidgetComponent } from "@edp-components/edp-smartnow-next-billing-widget/edp-smartnow-next-billing-widget.component";
import moment from "moment";
import { DependencyDataList } from "../types/DependencyList.interface";
import { WidgetCategory, WidgetItem } from "../types/WidgetItem.interface";
import { EdpWidgetCounterSavingsComponent } from "@edp-components/edp-card-widgets/edp-widget-counter-savings/edp-widget-counter-savings.component";
import { EdpWidgetOnboardingWhatsNewComponent } from "@edp-components/edp-card-widgets/edp-widget-onboarding-whats-new/edp-widget-onboarding-whats-new.component";
import { EdpWidgetConsumptionOmieComponent } from "@edp-components/edp-card-widgets/edp-widget-consumption-omie/edp-widget-consumption-omie.component";

const widgetsList: WidgetItem[] = [
    {
        name: "onboardingWhatsNew",
        category: WidgetCategory.D,
        component: EdpWidgetOnboardingWhatsNewComponent,
        dependencies: ["onboardingWhatsNew"],
        evaluateVisibility: (whatsNew: DependencyDataList) => {
            return !!whatsNew && !!whatsNew.onboardingWhatsNew;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    },
    {
        name: "smartNow",
        category: WidgetCategory.A,
        component: EdpWidgetSmartNowComponent,
        dependencies: ["contract", "smartNowDep"],
        evaluateVisibility: (d: DependencyDataList) => {
            return d.contract.SmartNow !== null && d.contract.SmartNow.ConfigurationDate === null && d.smartNowDep.status;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    },
    {
        name: "paymentDebt",
        category: WidgetCategory.A,
        component: EdpWidgetPaymentDebtComponent,
        dependencies: ["balanceData"],
        evaluateVisibility: (d: DependencyDataList) => {
            return d.balanceData.debtBalance > 0;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 2;
        },
    },
    {
        name: "billing",
        category: WidgetCategory.A,
        component: EdpWidgetBillingComponent,
        dependencies: ["balanceData", "contract"],
        evaluateVisibility: (d: DependencyDataList) => {
            return d.balanceData.balance > 0;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : d.contract.HasDirectDebit ? 1 : 2;
        },
    },
    {
        name: "withoutBilling",
        category: WidgetCategory.A,
        component: EdpWidgetWithoutBillingComponent,
        dependencies: ["balanceData", "contract"],
        // tslint:disable-next-line: object-literal-shorthand
        evaluateVisibility: function(d: DependencyDataList) {
            return this.getSlotsCount(d) > 0;
        },
        getSlotsCount: (d: DependencyDataList) => {
            if (
                d.balanceData.debtBalance <= 0 &&
                ((d.contract.HasContaCerta && d.balanceData.balance <= 0) ||
                    (!d.contract.HasContaCerta && d.balanceData.balance > 0 && d.contract.HasDirectDebit))
            ) {
                return 1;
            } else if (d.balanceData.debtBalance <= 0 && !d.contract.HasContaCerta && d.balanceData.balance <= 0) {
                return 2;
            } else {
                return 0;
            }
        },
    },
    {
        name: "contractConsumptions", // leituras
        category: WidgetCategory.A,
        component: EdpContractConsumptionsComponent,
        dependencies: ["contract", "contractDetails"],
        evaluateVisibility: (d: DependencyDataList) => {
            if (!d.contract || !d.contractDetails || d.contract.isInactive()) {
                return false;
            }
            return (
                !(d.contractDetails.getSelfConsumption() && d.contract.getType() === "electricity") &&
                ((d.contract.HasG && !d.contract.SmartNow) ||
                    (d.contract.HasG && d.contract.SmartNow && !d.contract.SmartNow.LastReadingG) ||
                    (d.contract.HasE && !d.contract.SmartNow))
            );
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    },
    {
        name: "contractConsumptionsOmie",
        category: WidgetCategory.A,
        component: EdpWidgetConsumptionOmieComponent,
        dependencies: ["contract"],
        evaluateVisibility: (d: DependencyDataList) => {
            if (!d.contract) {
                return false;
            }
            return d.contract.HasDynamicOfferE;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    },

    {
        name: "smartnowDashboard",
        category: WidgetCategory.A,
        component: EdpSmartnowDashboardWidgetComponent,
        dependencies: ["contract"],
        evaluateVisibility: (d: DependencyDataList) => {
            if (!d.contract.SmartNow || !d.contract.HasE || (d.contract.SmartNow && !d.contract.SmartNow.Simulation)) {
                return false;
            }

            const startDate = d.contract.SmartNow.Simulation.Ird_start;
            const endDate = d.contract.SmartNow.Simulation.Ird_end;
            return !isOnPeriod(startDate, endDate, d.contract.SmartNow.LastReadingE);
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return this.evaluateVisibility(d) ? 1 : 0;
        },
    },
    {
        name: "smartnowNextBilling",
        category: WidgetCategory.A,
        component: EdpSmartnowNextBillingWidgetComponent,
        dependencies: ["contract"],
        evaluateVisibility: (d: DependencyDataList) => {
            if (!d.contract.SmartNow || (d.contract.SmartNow && !d.contract.SmartNow.Simulation)) {
                return false;
            }

            const startDate = d.contract.SmartNow.Simulation.Ird_start;
            const endDate = d.contract.SmartNow.Simulation.Ird_end;
            const eletricityOnPeriod = isOnPeriod(startDate, endDate, d.contract.SmartNow.LastReadingE);
            const gasOnPeriod = isOnPeriod(startDate, endDate, d.contract.SmartNow.LastReadingG);
            let readingIsOnPeriod = false;

            if (d.contract.HasE && !d.contract.HasG) {
                readingIsOnPeriod = eletricityOnPeriod;
            }

            if (d.contract.HasG && !d.contract.HasE) {
                readingIsOnPeriod = gasOnPeriod;
            }

            if (d.contract.HasG && d.contract.HasE) {
                readingIsOnPeriod = eletricityOnPeriod || gasOnPeriod;
            }

            return readingIsOnPeriod;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return this.evaluateVisibility(d) ? 1 : 0;
        },
    },
    /* {
        name: "contaCerta",
        category: WidgetCategory.A,
        component: EdpWidgetContaCertaComponent,
        dependencies: ["contract"],
        evaluateVisibility: (d: DependencyDataList) => {
            return d.contract && d.contract.HasContaCerta;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    }, */

    {
        name: "partners",
        category: WidgetCategory.B,
        component: EdpWidgetPartnersComponent,
        dependencies: ["contract", "partner"],
        evaluateVisibility: (d: DependencyDataList) => {
            return d.contract.HasPack && d.partner.newPartners && d.partner.newPartners.length && d.partner.newPartners.length > 0;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    },
    {
        name: "funciona",
        category: WidgetCategory.B,
        component: EdpWidgetFuncionaComponent,
        dependencies: ["contract", "contractDetails"],
        evaluateVisibility: (d: DependencyDataList) => {
            if (!d.contract || !d.contractDetails || !d.contractDetails.getFunciona) {
                return false;
            }

            const funciona = d.contractDetails.getFunciona();
            return (
                (d.contract.HasPack instanceof HasPackModel || d.contract.HasServiceFunciona || d.contract.HasServiceFuncionaCA) &&
                funciona.plafond instanceof FuncionaPlafond
            );
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    },
    {
        name: "savings",
        category: WidgetCategory.B,
        component: EdpWidgetCounterSavingsComponent,
        dependencies: ["contract", "partner"],
        evaluateVisibility: (d: DependencyDataList) => {
            // TEMPORARY HIDDEN - PLAT-67140
            return false;
            // return !!d.contract.HasPack;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return !this.evaluateVisibility(d) ? 0 : 1;
        },
    },
    // {
    //     name: "advantagesAndBenefits",
    //     category: WidgetCategory.B,
    //     component: EdpWidgetAdvantagesAndBenefitsComponent,
    //     dependencies: ["contract", "partner"],
    //     evaluateVisibility: (d: DependencyDataList) => {
    //         return (
    //             d.contract.HasPack &&
    //             (!d.partner.newPartners || (d.partner.newPartners && !d.partner.newPartners.length)) &&
    //             d.partner.expiringCodes &&
    //             d.partner.expiringCodes.length &&
    //             d.partner.expiringCodes.length > 0
    //         );
    //     },
    //     // tslint:disable-next-line: object-literal-shorthand
    //     getSlotsCount: function(d: DependencyDataList) {
    //         return !this.evaluateVisibility(d) ? 0 : 1;
    //     },
    // },
    // {
    //     name: "savings",
    //     category: WidgetCategory.B,
    //     component: EdpWidgetSavingsComponent,
    //     dependencies: ["partner"],
    //     evaluateVisibility: (d: DependencyDataList) => {
    //         d = {
    //             partner: {
    //                 totalDiscounts: {
    //                     value: 3,
    //                     firstDiscountDate: "10-10-10"
    //                 },
    //                 expiringCodes: null,
    //                 newPartners: null,
    //                 partnerships: []
    //             }
    //         };
    //         // removed
    //         return false && d.partner.totalDiscounts && d.partner.totalDiscounts.value && d.partner.totalDiscounts.value > 1;
    //     },
    //     // tslint:disable-next-line: object-literal-shorthand
    //     getSlotsCount: function(d: DependencyDataList) {
    //         return !this.evaluateVisibility(d) ? 0 : 1;
    //     },
    // },
    // {
    //     name: "mobility",
    //     category: WidgetCategory.B,
    //     component: EdpWidgetMobilityComponent,
    //     dependencies: ["contract", "electricMobility"],
    //     evaluateVisibility: (d: DependencyDataList) => {
    //         return d.contract.HasM && d.electricMobility && d.electricMobility.value > 0;
    //     },

    //     getSlotsCount: function(d: DependencyDataList) {
    //         return !this.evaluateVisibility(d) ? 0 : 1;
    //     },
    // },
    {
        name: "requests",
        category: WidgetCategory.B,
        component: EdpWidgetRequestsComponent,
        dependencies: ["unexpiredContractRequests"],
        evaluateVisibility: (d: DependencyDataList) => {
            return d.unexpiredContractRequests.length > 0;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return this.evaluateVisibility(d) ? 1 : 0;
        },
    },
    {
        name: "health",
        category: WidgetCategory.B,
        component: EdpWidgetHealthComponent,
        dependencies: ["contract"],
        evaluateVisibility: (d: DependencyDataList) => {
            return (d.contract.HasPack && d.contract.HasPack.full) || d.contract.HasHealth;
        },
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return this.evaluateVisibility(d) ? 1 : 0;
        },
    },
    {
        name: "banner",
        category: WidgetCategory.C,
        component: EdpWidgetBannerComponent,
        dependencies: [],
        evaluateVisibility: () => false,
        // tslint:disable-next-line: object-literal-shorthand
        getSlotsCount: function(d: DependencyDataList) {
            return this.evaluateVisibility(d) ? 1 : 0;
        },
    },
];

function isOnPeriod(startDate: string, endDate: string, currentDate: string) {
    const today = moment();
    const periodStart = moment(startDate, "YYYY-MM-DD");
    const periodEnd = moment(endDate, "YYYY-MM-DD").add(3, "d");
    const currentPeriod = moment(currentDate, "YYYY-MM-DD HH:mm:ss");
    return (
        currentPeriod.isSameOrAfter(periodStart) &&
        currentPeriod.isSameOrBefore(periodEnd) &&
        today.isSameOrAfter(periodStart) &&
        today.isSameOrBefore(periodEnd)
    );
}

export default widgetsList;
